import { render, staticRenderFns } from "./publishC2c.vue?vue&type=template&id=37b9de52&scoped=true&"
import script from "./publishC2c.vue?vue&type=script&lang=js&"
export * from "./publishC2c.vue?vue&type=script&lang=js&"
import style0 from "./publishC2c.vue?vue&type=style&index=0&id=37b9de52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9de52",
  null
  
)

export default component.exports